__webpack_require__.p = "https://bmidxbindonesiaplprod.netlify.app/";